module.exports = __webpack_public_path__ + "img/f3.770cdbd1.png";